import {SearchKeywordInput} from '../../../graphql/generated/types';
import {
  SEARCH_DEFAULT_CATEGORY_UID,
  SEARCH_KEYWORD_DEFAULT_SORT_TYPE,
} from '../constant';
import {
  SearchKeywordSearchParam,
  validateCategoryUid,
  validateSearchKeywordSortType,
} from './typeguard';

export function createSearchKeywordInput(
  searchParam: SearchKeywordSearchParam
) {
  return {
    keyword: searchParam.keyword,
    categoryUid: validateCategoryUid(searchParam?.categoryUid)
      ? searchParam.categoryUid
      : SEARCH_DEFAULT_CATEGORY_UID,
    showOnlyComplete: searchParam?.showOnlyComplete === 'true' || false,
    sortType: validateSearchKeywordSortType(searchParam?.sortType)
      ? searchParam.sortType
      : SEARCH_KEYWORD_DEFAULT_SORT_TYPE,
  } as SearchKeywordInput;
}
